"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorBlue = '#1A699E'; // from TFS 929971
exports.DarkGreenText = '#008057';
exports.userSelectStyle = {
    userSelect: 'text',
    '-webkit-user-select': 'text',
    '-moz-user-select': 'text',
    '-ms-user-select': 'text',
};
// These colors are referenced in the DQW tooltip
exports.DataQualityDetailPanelWidth = 300;
exports.DataQualityDetailPanelMaxHeight = 500;
exports.DataQualityStatusChipBackground = '#D7ECF9';
exports.DataQualityStatusTitleColor = '#0F445E';
//# sourceMappingURL=StyleConstants.js.map